import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const MosaicRailContainer = styled.div`
  height: ${630 * Screen.widthRatio}px;
  position: relative;
  width: ${1460 * Screen.widthRatio}px;
`;

export default withAnimation(MosaicRailContainer);
